export const XR_FOCUS_VIEW_MOVEMENT_KEY_CODES = new Set([
  "KeyW",
  "KeyA",
  "KeyS",
  "KeyD",
  "KeyQ",
  "KeyE",
  "Space",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
]);

export const XR_FOCUS_VIEW_MODIFIER_CAMERA_KEY_CODES = new Set([
  "Equal",
  "Minus",
  "NumpadAdd",
  "NumpadSubtract",
  "Digit0",
  "Numpad0",
  "KeyF",
]);

export const isEditableShortcutTarget = (target: EventTarget | null): boolean => {
  if (
    !target ||
    typeof target !== "object" ||
    !("nodeType" in target) ||
    (target as Node).nodeType !== Node.ELEMENT_NODE
  ) {
    return false;
  }

  const element = target as HTMLElement;
  if (element.isContentEditable) return true;

  return Boolean(
    element.closest(
      'input, textarea, select, [contenteditable="true"], [role="textbox"], .MuiInputBase-root, .MuiInputBase-input',
    ),
  );
};

export const isImeComposingEvent = (event: KeyboardEvent): boolean =>
  event.isComposing || event.keyCode === 229;

export const matchesPhysicalKey = (
  event: KeyboardEvent,
  code: "KeyG" | "KeyL" | "KeyM" | "KeyR" | "KeyT" | "KeyZ",
  fallbackKey: string,
): boolean => {
  if (event.code === code) return true;
  return event.code === "" && event.key.toLowerCase() === fallbackKey;
};

export const getShortcutWindows = (): Window[] => {
  const windows: Window[] = [window];
  const iframe = document.getElementById("unity-iframe") as HTMLIFrameElement | null;

  if (iframe?.contentWindow && iframe.contentWindow !== window) {
    windows.push(iframe.contentWindow);
  }

  return windows;
};

export const isApplePlatform = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);
};
